import { TaskActionTypes } from "./task-types";
import {
        GetTasksNew,
        GetUserTasksForWeb,
        GetSubTasksNew,
        GetDocumentOriginal,
        GetDocumentOriginalBlackline,
        GetDocument,
        GetDocumentCopy,
        GetAssignmentExcelPath,
        GetDocumentLive,
        GetDocumentLiveBlackline
    } from "../../services/api/task-api";
import {
        ViewExcelAssignedContent,
        ViewExcelChangedContent,
        ViewExcelUpdatedContent,
        DownloadExcelAssignedContentRow,
        DownloadExcelAssignedContentColumn,
        DownloadExcelChangedContentRow,
        DownloadExcelChangedContentColumn
    } from "../../services/api/document-api";
import {
        GetPowerpointImagePreviews,
        ApprovePowerPointTask,
        DeclinePowerPointTask,
        CancelPowerPointTask,
        AddPowerPointComment,
        GetTaskDocumentPowerpoint
    } from '../../services/api/ppt-new-api';
import { OLD_UI_URL } from "../../services/api/api-client";
import { saveAs } from 'file-saver';

export const getTasks = () => { //to get all the tasks
    return async (dispatch, getState) => { //getState lets you access redux state in actions

        let tasks = [];

        dispatch(fetchTasksStart()); //start loader

        try {
            let allTasks = await GetUserTasksForWeb();

            allTasks.Tasks.forEach( (task1) => {

                let permission = 'View';
                // set PERMISSION
                task1.CreatedById === getState().currentUser.userID ?  //if task is assignedBy user logged in, then permission is Owner. If owner then add additional permission like Approve, Edit etc. to permission. O/w just set permission.
                    permission = task1.Permission === 'Owner' ? 'Owner' : `Owner (${task1.Permission})`
                : permission = task1.Permission;


                tasks.push({
                    ...task1,
                    subtaskOpen: false,
                    subtask: [],
                    splitScreen: false,
                    actionsParams: ['changedContent'],
                    Permission: permission
                })
            });

            dispatch(setTasks(tasks)); //setting the 10 tasks to display.

            dispatch(setCountAndProjectList({
                taskCount: {  //setting the number of total tasks in each tab.
                    all: allTasks.AllTasks,
                    active: allTasks.ActiveTasks,
                    completed:allTasks.CompletedTasks,
                    archived: allTasks.ArchivedTasks,
                    pagination: allTasks.Pagination
                },

                projects: allTasks.FilterProjects //setting project list for project filter table.
            }));
            // setting the taskQuery
            // dispatch(setTaskQuery(taskQuery));

            dispatch(fetchTasksSuccess()); //stop loader

            return allTasks;

        } catch (error) {
            dispatch(fetchTasksFailure(error));
            console.log(error);
        }
    }
}

export const showSubtask = (taskId) => {
    return async (dispatch, getState) => {

        let tasks = getState().tasks.tasksGrouped;

        let tasksWithSubtaskOpen = {
            'active': [],
            'completed': [],
            'archived': [],

            'urgent': [],
            'high': [],
            'medium': [],
            'low': [],

            'viewer': [],
            'editor': [],
            'approver': [],
            'owner': [],

            'standard': [],
            'word': [],
            'excel': [],
            'powerpoint': [],

            'actionable': [],
            'nonActionable': [],

            'none': [],
        };

        try {

            let subtasks =  await GetSubTasksNew(taskId);
            let subtasksModded = [];

            subtasks.map(subtask1 => {

                let permission = '';

                 // set PERMISSION
                if (subtask1.Permission === 'Owner' && subtask1.CreatedById === getState().currentUser.userID) permission = "Owner";
                else if (subtask1.CreatedById === getState().currentUser.userID) permission = `Owner (${subtask1.Permission})`;

                subtasksModded.push({...subtask1, Permission: permission});

            })

            for (const groupBy in tasks) {
                tasks[groupBy].forEach(task => {
                        task.Id === taskId ? tasksWithSubtaskOpen[groupBy].push({ ...task, 'subtaskOpen': !task.subtaskOpen, 'subtask': subtasksModded}) : tasksWithSubtaskOpen[groupBy].push(task)
                })
            }

        } catch (error) {
            console.log(error);
        }

        dispatch(setTasksGrouped({
            'active': tasksWithSubtaskOpen['active'],
            'completed': tasksWithSubtaskOpen['completed'],
            'archived': tasksWithSubtaskOpen['archived'],

            'urgent': tasksWithSubtaskOpen['urgent'],
            'high': tasksWithSubtaskOpen['high'],
            'medium': tasksWithSubtaskOpen['medium'],
            'low': tasksWithSubtaskOpen['low'],

            'viewer': tasksWithSubtaskOpen['viewer'],
            'editor': tasksWithSubtaskOpen['editor'],
            'approver': tasksWithSubtaskOpen['approver'],
            'owner': tasksWithSubtaskOpen['owner'],

            'standard': tasksWithSubtaskOpen['standard'],
            'word': tasksWithSubtaskOpen['word'],
            'excel': tasksWithSubtaskOpen['excel'],
            'powerpoint': tasksWithSubtaskOpen['powerpoint'],

            'actionable': tasksWithSubtaskOpen['actionable'],
            'nonActionable': tasksWithSubtaskOpen['nonActionable'],

            'none': tasksWithSubtaskOpen['none'],
        }));

    }
}

export const getTasksGrouped = (groupBy) => {
    return async (dispatch, getState) => {
        try {
            let active = [];
            let completed = [];
            let archived = [];

            let urgent = [];
            let high = [];
            let medium = [];
            let low = [];

            let viewer = [];
            let editor = [];
            let approver = [];
            let owner = [];

            let standard = [];
            let word = [];
            let excel = [];
            let powerpoint = [];

            let actionable = [];
            let nonActionable = [];

            dispatch(fetchTasksStart());

            dispatch(setSelectedTasks([]))

            dispatch(setGroupTasksBy(groupBy));

            let tasks = await GetUserTasksForWeb();

            let currUser = getState().currentUser.userID;

            if(groupBy.toLowerCase() === 'category') {

                tasks.Tasks.forEach(task => {
                    let permission = task.Permission;

                    if (task.Permission === 'Owner' && task.CreatedById === getState().currentUser.userID) permission = "Owner";
                    else if (task.CreatedById === getState().currentUser.userID) permission = `Owner (${task.Permission})`;
                    if(!task.StatusAndButtons || !task.StatusAndButtons?.Status || !task.Permission){
                        return;
                    }
                    const tempCategory = task.StatusAndButtons.Status.toLowerCase();
                    if (tempCategory.includes("archived"))  {
                        archived.push({
                            ...task,
                            subtaskOpen: false,
                            subtask: [],
                            splitScreen: false,
                            actionsParams: ['changedContent'],
                            Permission: permission
                        })
                    } else if (tempCategory.includes("completed") || tempCategory.includes("cancelled") || tempCategory.includes("approved"))  {
                        completed.push({
                            ...task,
                            subtaskOpen: false,
                            subtask: [],
                            splitScreen: false,
                            actionsParams: ['changedContent'],
                            Permission: permission
                        })
                    } else {
                        active.push({
                            ...task,
                            subtaskOpen: false,
                            subtask: [],
                            splitScreen: false,
                            actionsParams: ['changedContent'],
                            Permission: permission
                        })
                    }
                });

                dispatch(setTasksGrouped({...getState().tasks.tasksGrouped, 'active': active, 'completed': completed, 'archived': archived }));

            }

            if(groupBy.toLowerCase() === 'priority') {

                tasks.Tasks.forEach(task => {
                    let permission = task.Permission;

                    if (task.Permission === 'Owner' && task.CreatedById === getState().currentUser.userID) permission = "Owner";
                    else if (task.CreatedById === getState().currentUser.userID) permission = `Owner (${task.Permission})`;

                    if(!task.StatusAndButtons || !task.StatusAndButtons?.Status || task.Members.length===0 || !task.Permission){
                        return;
                    }
                    if (task.Priority.toLowerCase().includes('urgent')) {
                        urgent.push({
                            ...task,
                            subtaskOpen: false,
                            subtask: [],
                            splitScreen: false,
                            actionsParams: ['changedContent'],
                            Permission: permission
                        })
                    } else if (task.Priority.toLowerCase().includes('high')) {
                        high.push({
                            ...task,
                            subtaskOpen: false,
                            subtask: [],
                            splitScreen: false,
                            actionsParams: ['changedContent'],
                            Permission: permission
                        })
                    } else if (task.Priority.toLowerCase().includes('medium')) {
                        medium.push({
                            ...task,
                            subtaskOpen: false,
                            subtask: [],
                            splitScreen: false,
                            actionsParams: ['changedContent'],
                            Permission: permission
                        })
                    } else  {
                        low.push({
                            ...task,
                            subtaskOpen: false,
                            subtask: [],
                            splitScreen: false,
                            actionsParams: ['changedContent'],
                            Permission: permission
                        })
                    }
                });

                dispatch(setTasksGrouped({...getState().tasks.tasksGrouped, 'urgent': urgent, 'high': high, 'medium': medium, 'low' : low }));

            }

            if(groupBy.toLowerCase() === 'permission') {
                tasks.Tasks.forEach(task => {
                    let permission = task.Permission;

                    if (task.Permission === 'Owner' && task.CreatedById === getState().currentUser.userID) permission = "Owner";
                    else if (task.CreatedById === getState().currentUser.userID) permission = `Owner (${task.Permission})`;
                    if(!task.StatusAndButtons || !task.StatusAndButtons?.Status || task.Members.length===0 || !task.Permission){
                        return;
                    }
                    if (task.assignedBy === currUser) {
                        owner.push({
                            ...task,
                            subtaskOpen: false,
                            subtask: [],
                            splitScreen: false,
                            actionsParams: ['changedContent'],
                            Permission: permission
                        })
                    } else if (task.Permission.toLowerCase().includes('view')) {
                        viewer.push({
                            ...task,
                            subtaskOpen: false,
                            subtask: [],
                            splitScreen: false,
                            actionsParams: ['changedContent'],
                            Permission: permission
                        })
                    } else if (task.Permission.toLowerCase().includes('approve')) {
                        approver.push({
                            ...task,
                            subtaskOpen: false,
                            subtask: [],
                            splitScreen: false,
                            actionsParams: ['changedContent'],
                            Permission: permission
                        })
                    } else {
                        editor.push({
                            ...task,
                            subtaskOpen: false,
                            subtask: [],
                            splitScreen: false,
                            actionsParams: ['changedContent'],
                            Permission: permission
                        })
                    }
                });

                dispatch(setTasksGrouped({...getState().tasks.tasksGrouped, 'viewer': viewer, 'editor': editor, 'approver': approver, 'owner' : owner }));

            }

            if(groupBy.toLowerCase() === 'tasktype') {

                tasks.Tasks.forEach(task => {
                    let permission = task.Permission;

                    if (task.Permission === 'Owner' && task.CreatedById === getState().currentUser.userID) permission = "Owner";
                    else if (task.CreatedById === getState().currentUser.userID) permission = `Owner (${task.Permission})`;
                    if(!task.StatusAndButtons || !task.StatusAndButtons?.Status || task.Members.length===0 || !task.Permission){
                        return;
                    }
                    if (task.TaskTypeId === 1) {
                        standard.push({
                            ...task,
                            subtaskOpen: false,
                            subtask: [],
                            splitScreen: false,
                            actionsParams: ['changedContent'],
                            Permission: permission
                        })
                    } else if (task.DocumentTypeId === 1) {
                        word.push({
                            ...task,
                            subtaskOpen: false,
                            subtask: [],
                            splitScreen: false,
                            actionsParams: ['changedContent'],
                            Permission: permission
                        })
                    } else if (task.DocumentTypeId === 2) {
                        excel.push({
                            ...task,
                            subtaskOpen: false,
                            subtask: [],
                            splitScreen: false,
                            actionsParams: ['changedContent'],
                            Permission: permission
                        })
                    } else {
                        powerpoint.push({
                            ...task,
                            subtaskOpen: false,
                            subtask: [],
                            splitScreen: false,
                            actionsParams: ['changedContent'],
                            Permission: permission
                        })
                    }
                });

                dispatch(setTasksGrouped({...getState().tasks.tasksGrouped, 'standard': standard, 'word': word, 'excel': excel, 'powerpoint' : powerpoint }));

            }

            if(groupBy.toLowerCase() === 'action') {

                tasks.Tasks.forEach(task => {
                    let permission = task.Permission;

                    if (task.Permission === 'Owner' && task.CreatedById === getState().currentUser.userID) permission = "Owner";
                    else if (task.CreatedById === getState().currentUser.userID) permission = `Owner (${task.Permission})`;
                    if(!task.StatusAndButtons || !task.StatusAndButtons?.Status || task.Members.length===0 || !task.Permission){
                        return;
                    }
                    if (task.IsActionable  === true) {
                        actionable.push({
                            ...task,
                            subtaskOpen: false,
                            subtask: [],
                            splitScreen: false,
                            actionsParams: ['changedContent'],
                            Permission: permission
                        })
                    } else {
                        nonActionable.push({
                            ...task,
                            subtaskOpen: false,
                            subtask: [],
                            splitScreen: false,
                            actionsParams: ['changedContent'],
                            Permission: permission
                        })
                    }
                });

                dispatch(setTasksGrouped({...getState().tasks.tasksGrouped, 'actionable': actionable, 'nonActionable': nonActionable }));

            }

            if(groupBy.toLowerCase() === 'none') {

                let none = tasks.Tasks.filter(task=>task.StatusAndButtons).map( task => {
                    let permission = task.Permission;
                    if (task.Permission === 'Owner' && task.CreatedById === getState().currentUser.userID) permission = "Owner";
                    else if (task.CreatedById === getState().currentUser.userID) permission = `Owner (${task.Permission})`;
                    return {
                        ...task,
                        subtaskOpen: false,
                        subtask: [],
                        splitScreen: false,
                        actionsParams: ['changedContent'],
                        Permission: permission
                    }
                })

                dispatch(setTasksGrouped({...getState().tasks.tasksGrouped, 'none': none}));
            }

            let TaskCounts1 = {
                all: tasks.AllTasks,
                active: tasks.ActiveTasks,
                completed: tasks.CompletedTasks,
                archived: tasks.ArchivedTasks,
                pagination: tasks.Pagination
            }

            dispatch(setCountAndProjectList({
                taskCount: TaskCounts1,
                projects: tasks.FilterProjects  //setting project list for project filter table.
            }));

            dispatch(setTasks(tasks.Tasks));

            // setting query in redux
            dispatch(fetchTasksSuccess());


        } catch (error) {
            dispatch(fetchTasksFailure(error));
            dispatch(resetTasks());
            console.log(error);
        }
    }
}


export const fetchTasksStart = () => ({
    type: TaskActionTypes.FETCHING_TASKS_START
})

export const fetchTasksSuccess = () => ({
    type: TaskActionTypes.FETCHING_TASKS_SUCCESS
})

export const fetchTasksFailure = (errorMessage) => ({
    type: TaskActionTypes.FETCHING_TASKS_FAILURE,
    payload: errorMessage
})

export const setTasks = (tasks) => ({
    type: TaskActionTypes.SET_TASKS,
    payload: tasks
})

export const setTaskQuery = (taskQuery) => ({
    type: TaskActionTypes.SET_TASK_QUERY,
    payload: taskQuery
})

export const setCountAndProjectList = (taskCountAndProjectList) => ({
    type: TaskActionTypes.SET_TASK_COUNT_AND_PROJECT_LIST,
    payload: taskCountAndProjectList
})

export const fetchCountStart = () => ({
    type: TaskActionTypes.FETCHING_COUNT_START
})

export const fetchCountSuccess = () => ({
    type: TaskActionTypes.FETCHING_COUNT_SUCCESS
})

export const fetchCountFailure = () => ({
    type: TaskActionTypes.FETCHING_COUNT_FAILURE
})


export const setGroupTasksBy = (groupBy) => ({
    type: TaskActionTypes.SET_GROUP_TASKS_BY,
    payload: groupBy
})

export const setTasksGrouped = (tasksGrouped) => ({
    type: TaskActionTypes.SET_TASKS_GROUPED,
    payload: tasksGrouped
})

export const setTaskCounts = (taskCounts) => ({
    type: TaskActionTypes.SET_TASK_COUNTS,
    payload: taskCounts
})

export const addSelectedTask = (taskId) => ({
    type: TaskActionTypes.ADD_SELECTED_TASKS,
    payload: taskId
})

export const deleteSelectedTask = (taskId) => ({
    type: TaskActionTypes.DELETE_SELECTED_TASKS,
    payload: taskId
})

export const addMultipleSelectedTasks = (taskIdList) => ({
    type: TaskActionTypes.ADD_MULTIPLE_SELECTED_TASKS,
    payload: taskIdList
})

export const deleteMultipleSelectedTasks = (taskIdList) => ({
    type: TaskActionTypes.DELETE_MULTIPLE_SELECTED_TASKS,
    payload: taskIdList
})

////////////////////////////////////////////////////

//VIEW DOCUMENT ACTIONs

export const viewWordDocument = (docId, actionType) => { //UPDATED DOCUMENT
    return async dispatch => {
        try {

            let docPath = '';
            let originalDocPath = '';
            let docpathBlackline = '';

            dispatch(fetchDocumentStart()); //starting the loader for normal doc

            if (actionType === 'Updated Document') {

                docPath = await GetDocumentOriginal(docId);
                docpathBlackline = await GetDocumentOriginalBlackline(docId); //also set the blackline path

                dispatch(fetchDocumentFinish());
            }

            else if (actionType === 'Changed Content') {
                docPath = await GetDocument(docId);
                dispatch(fetchDocumentFinish());
            }

            else if (actionType === 'Assigned Content') {
                docPath = await GetDocumentCopy(docId);
                //setting loader back to false
                dispatch(fetchDocumentFinish());

                console.log(docPath, docId);

            }
            else if(actionType === "Live Document"){
                docPath = await GetDocumentLive(docId);
                docpathBlackline = await GetDocumentLiveBlackline(docId); //also set the blackline path
                dispatch(fetchDocumentFinish());
            }


            //setting docPath to redux state
            dispatch(setDocPath(docPath));
            dispatch(setOriginalDocPath(originalDocPath));
            dispatch(setDocPathBlackline(docpathBlackline));

        } catch (error) {
            dispatch(setDocPath(""));
            dispatch(setOriginalDocPath(""));
            dispatch(fetchDocumentFailure());
            console.log(error);
        }

    }
}

export const excelDocumentActions = (task, actionType, userID, token, commentID) => {
    return async dispatch => {
        try {

            let viewObj = {originalDocumentName: task.DocumentFile, name: task.DocumentFile, Action: 1, IsReadOnly: true, assignmentId: task.Id, userid: userID};
            let downloadObj = {FileName: task.DocumentFile, AssignmentId: task.Id};
            let docPath = '';
            let originalDocPath = '';
            let docpathBlackline = '';

            dispatch(fetchDocumentStart()); //starting the loader for normal doc

            if (actionType === 'Updated Document') {
                let result = await ViewExcelUpdatedContent(token, viewObj);
                let strArray = result.split("\"")
                let docPathArray = [];
                strArray.forEach(element => {
                    if (element.includes("ApplicationDocuments/Files"))
                    {
                        docPathArray.push(OLD_UI_URL + element);
                    }
                });
                docPath = docPathArray[1];
                docpathBlackline = docPathArray[0];
                dispatch(fetchDocumentFinish());
            }

            else if (actionType === 'Changed Content') {
                let result = await ViewExcelChangedContent(token, viewObj);
                let strArray = result.split("\"")
                let docPathArray = [];
                strArray.forEach(element => {
                    if (element.includes("ApplicationDocuments/Files"))
                    {
                        docPathArray.push(OLD_UI_URL + element);
                    }
                });
                originalDocPath = docPathArray[0];
                docPath = docPathArray[1];
                dispatch(fetchDocumentFinish());
            }

            else if (actionType === 'Assigned Content') {
                let result = await ViewExcelAssignedContent(token, viewObj);
                let strArray = result.split("\"")
                strArray.forEach(element => {
                    if (element.includes("ApplicationDocuments/Files"))
                    {
                        docPath = OLD_UI_URL + element;
                    }
                });
                dispatch(fetchDocumentFinish());
            }

            else if (actionType === 'Download Assigned Content') {
                let strArray = task.DocumentFile.split(".");
                let extension = strArray[strArray.length - 1];
                let downloadName = "Triyo_Task_" + task.Id.toString() + "." + extension;
                if (task.Document.AssignmentType === "row")
                {
                    let result = await DownloadExcelAssignedContentRow(token, downloadObj);
                    saveAs(result, downloadName);
                }
                else if (task.Document.AssignmentType === "column")
                {
                    let result = await DownloadExcelAssignedContentColumn(token, downloadObj);
                    saveAs(result, downloadName);
                }
                dispatch(fetchDocumentFinish());
            }

            else if (actionType === 'Download Changed Content') {
                let strArray = task.DocumentFile.split(".");
                let extension = strArray[strArray.length - 1];
                let downloadName = "Triyo_Task_" + task.Id.toString() + "." + extension;
                if (task.Document.AssignmentType === "row")
                {
                    let result = await DownloadExcelChangedContentRow(token, downloadObj);
                    saveAs(result, downloadName);
                }
                else if (task.Document.AssignmentType === "column")
                {
                    let result = await DownloadExcelChangedContentColumn(token, downloadObj);
                    saveAs(result, downloadName);
                }
                dispatch(fetchDocumentFinish());
            }

            else if (actionType === "Audit Trail") {
                let result = await GetAssignmentExcelPath({id: commentID, type: task.Document.AssignmentType});
                if (result.length === 1) {
                    docPath = OLD_UI_URL + result[0];
                }
                else if (result.length === 2) {
                    originalDocPath = OLD_UI_URL + result[0];
                    docPath = OLD_UI_URL + result[1];
                }
                dispatch(fetchDocumentFinish());
            }

            //setting docPath to redux state
            dispatch(setDocPath(docPath));
            dispatch(setOriginalDocPath(originalDocPath));
            dispatch(setDocPathBlackline(docpathBlackline));

        } catch (error) {
            dispatch(fetchDocumentFailure());
            console.log(error);
        }

    }
}

export const viewPowerpointDocument = (assignmentId) => {
    return async dispatch => {
        try {
            dispatch(fetchDocumentStart());
            const result = await GetPowerpointImagePreviews(assignmentId);

            //make api for download
            //audit trail: based on comment action show version?

            var resultObj = {
                lockedSlides: result.LockedSlides,
                assignedSlides: result.WordDocumentPdfOriginalBase64,
                changedSlides: result.WordDocumentPdfUpdatedBase64,
                originalSlides: result.WordProjectDocumentPdfOriginalBase64,
                updatedSlides: result.WordProjectDocumentPdfUpdatedBase64,
                fileNameId: result.DocumentPowerpoint[0].FileNameId,
                fileName: result.DocumentPowerpoint[0].FileName
            }

            dispatch(setPPTDocumentDetails(resultObj));

            dispatch(fetchDocumentFinish());
        } catch (error) {
            dispatch(fetchDocumentFailure());
            console.log(error);
        }

    }
}

export const submitPowerpointDocument = (assignmentId, actionType, commentText) => {
    return async (dispatch, getState) => {
        try {
            const currStatePptDoc = getState().tasks.pptDocument;
            dispatch(submitDocumentStart());
            let documentResult = null;
            let commentResult = null;
            let file = null;
            let commentActionId = 7;
            if(actionType === "Approve")
                commentActionId = 3;
            else if(actionType === "Complete")
                commentActionId = 3;
            else if(actionType === "Decline")
                commentActionId = 4;
            else if(actionType === "Cancel")
                commentActionId = 8;

            const fdDocument = new FormData();
            const fdComment = new FormData();

            //get file
            if(actionType === "Approve" || actionType === "Complete" || actionType === "Decline" || actionType === "Cancel"){
                const fileNameId = currStatePptDoc.fileNameId;
                const fileName = currStatePptDoc.fileName;
                const fileBase64String = await GetTaskDocumentPowerpoint(fileNameId);
                const mimeType = 'application/vnd.openxmlformats-officedocument.presentationml.presentation';

                const dataURL = `data:${mimeType};base64,${fileBase64String}`;
                file = dataURLtoFile(dataURL, fileName);

                fdComment.append("note", commentText);
                fdComment.append("taskId", assignmentId);
                fdComment.append("noteAction", commentActionId);

                commentResult = await AddPowerPointComment(fdComment);

                let commentId = commentResult.Comments.pop().Id;
                fdDocument.append("commentId", commentId);
                fdDocument.append("ActionId", commentActionId);
            }

            //submit document
            if(actionType === "Approve" || actionType === "Complete"){
                fdDocument.append("file", file);
                documentResult = await ApprovePowerPointTask(fdDocument);
            }
            else if(actionType === "Decline"){
                fdDocument.append("file", file);
                documentResult = await DeclinePowerPointTask(fdDocument);
            }
            else if(actionType === "Cancel"){
                fdDocument.append("file", file);
                fdDocument.append("docType", "PowerPoint");
                documentResult = await CancelPowerPointTask(fdDocument);
            }

            let result = (documentResult === "Error, API Failure" || commentResult === "Error, API Failure" ? "Error, API Failure" : "");

            dispatch(submitDocumentFinish(result));

        } catch (error) {
            dispatch(submitDocumentFailure(error));
            console.log(error);
        }

    }
}

const dataURLtoFile = (dataurl, filename) => {

    var arr = dataurl.split(','),
        mime = arr[0].match(/:(.*?);/)[1], //uses regex to find mimetype
        bstr = atob(arr[1]), //uses atob function to decode the base64string
        n = bstr.length,
        u8arr = new Uint8Array(n);

    while(n--){
        u8arr[n] = bstr.charCodeAt(n);
    }

    return new File([u8arr], filename, {type:mime});
}

export const setPPTDocumentDetails = (document) => ({
    type: TaskActionTypes.SET_PPT_DOCUMENT_DETAILS,
    payload: document
})

export const setDocPath = (docpath) => ({
    type: TaskActionTypes.SET_DOCPATH,
    payload: docpath
})

export const setOriginalDocPath = (originalDocPath) => ({
    type: TaskActionTypes.SET_ORIGINAL_DOCPATH,
    payload: originalDocPath
})

export const setDocPathBlackline = (docpathBlackline) => ({
    type: TaskActionTypes.SET_DOCPATH_BLACKLINE,
    payload: docpathBlackline
})

export const fetchDocumentStart = () => ({
    type: TaskActionTypes.FETCHING_DOCUMENT_START
})

export const fetchDocumentFinish = () => ({
    type: TaskActionTypes.FETCHING_DOCUMENT_FINISH
})

export const fetchDocumentFailure = () => ({
    type: TaskActionTypes.FETCHING_DOCUMENT_FAILURE
})

export const submitDocumentStart = () => ({
    type: TaskActionTypes.SUBMIT_DOCUMENT_START
})

export const submitDocumentFinish = (result) => ({
    type: TaskActionTypes.SUBMIT_DOCUMENT_FINISH,
    payload: result,
})

export const submitDocumentFailure = (error) => ({
    type: TaskActionTypes.SUBMIT_DOCUMENT_FAILURE,
    payload: error,
})

export const setSelectedTasks = (selectedTasks) => ({
    type: TaskActionTypes.SET_SELECTED_TASKS,
    payload: selectedTasks,
})

export const resetTasks = () => ({
    type: TaskActionTypes.RESET_TASKS,
})